/**
 * This file contains constants for shared/default rendering id values.
 */
export const toolGroupId = 'exampleToolGroup';
export const renderingEngineId = 'exampleRenderingEngine';
export const viewportId = 'exampleViewportMain';
